module.exports = __webpack_public_path__ + "static/discovery-9ee11eed5a216c35ff5535e0322a34c0.png";